
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Game } from '@/model/game.model'
import { useStore } from 'vuex'

@Options({})
export default class GameIFrame extends Vue {
  @Prop({ required: true }) url!: string
  @Prop({ required: true }) token!: string
  @Prop({ required: false }) isHiddenNavbar?: boolean
  @Prop({ required: false }) queryParameter?: string
  store = useStore()

  iFrameName = Game.IFRAME_NAME
  socialToken = this.store.state.lineInfo?.socialToken ?? undefined

  get iframeUrl(): string {
    const separator = this.url.includes('?') ? '&' : '?'
    let destinationUrl = `${this.url}${separator}token=${this.token}`

    if (this.socialToken) {
      destinationUrl += `&lineaccessToken=${this.socialToken}`
    }

    if (this.queryParameter) {
      destinationUrl += `&${this.queryParameter}`
    }

    return destinationUrl
  }

  closeModal() {
    this.$emit('close')
  }
}
